import { NetworkError } from '../lib/custom-errors'
import { useUseCountriesCountriesQuery } from '../graphql'

const useCountries = () => {
  const { data, loading, error } = useUseCountriesCountriesQuery()

  if (error) {
    if (error.networkError) {
      throw new NetworkError('There was a connection error when trying to fetch countries', error.networkError.message)
    }

    throw new Error(`${error.name} - ${error.message}`)
  }

  return { countries: data && data.countries, isLoading: loading }
}

export default useCountries
